/*LIST*/
Vue.component('user_profile_header_widget', {
    template:'#userprofileheaderwidget-template',

    data:function(){
        return{
            user:[]
        };
    },
    created:function(){

        headerProfileInstance = this;
        headerProfileInstance.getUserData();

        $(document).click(function (e) {
            e.stopPropagation();
            var container = $("#userprofileheaderwidget");

            if (container.has(e.target).length === 0) {
                $(".user_profile_menu").removeClass("visible");
            }
        });

    },
    methods: {

        getUserData:function(){
            axios.get(baseURL+'/api/user/info').then(function(response){
                headerProfileInstance.user = response.data;
            });
        }

    },
    computed:{
      monogram:function(){
          var result = headerProfileInstance.user.firstname.substring(0,1);
          result += headerProfileInstance.user.lastname.substring(0,1);
          result = result.toUpperCase();
          return result;
      }
    }
});